export const Cloudinary = {
  CLOUD_NAME: 'nomina',
  PRESET_NAME: 'nomina_emp',
};
